import { render, staticRenderFns } from "./ChannelInvite.vue?vue&type=template&id=32d5efa6&scoped=true&lang=pug&"
import script from "./ChannelInvite.vue?vue&type=script&lang=js&"
export * from "./ChannelInvite.vue?vue&type=script&lang=js&"
import style0 from "./ChannelInvite.vue?vue&type=style&index=0&id=32d5efa6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5efa6",
  null
  
)

export default component.exports